import searchLogo from "../assets/images/searchLogo.svg";
import { status } from "./constants";
import editIcon from '../assets/images/editIcon.png';
import TickerHyperLinkComponent from "../components/TickerHyperLinkComponent";
import { rateFormatter } from "./commonFunctions";

function is_number(char: any) {
  {
    return !isNaN(parseInt(char));
  }
}

var myValueFormatter_quantity = (p: any) => {
  let is_n = is_number(p.value);
  if (is_n) {
    return formatNumber_q.format(p.value);
  }
};

const formatNumber_q = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 2,
});

export const RateChangeDefs = [
  {
    headerName: "Contract Id",
    field: "contract_id",
    floatingFilter: false,
    editable: false,
    filter: "agTextColumnFilter",
    lockPinned: true,
    cellClass: "lock-pinned",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "0.5px solid #E1E1E1",
    },
    minWidth: 95,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "B/L",
    field: "contract_type",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 72,
    maxWidth: 80,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Cpty Id",
    field: "cpty_id",
    filter: "agTextColumnFilter",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 75,
    maxWidth: 100,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Cpty Name",
    field: "cpty_name",
    floatingFilter: false,
    editable: false,
    filter: "agSetColumnFilter",
    hide: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 170,
    maxWidth: 250,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Ticker",
    field: "ticker",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 50,
    maxWidth: 180,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    cellRenderer: TickerHyperLinkComponent
  },
  {
    headerName: "Cusip",
    field: "cusip",
    floatingFilter: false,
    editable: false,
    filter: "agTextColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "0.5px solid #E1E1E1",
    },
    minWidth: 85,
    maxWidth: 180,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    // filterParams: {
    //   allowedCharPattern: "\\d\\-\\,",
    //   numberParser: (text: any) => {
    //     return parseFloat(text.replace(",", ""));
    //   },
    // },
  },
  {
    headerName: "Security Name",
    field: "secMaster_name",
    floatingFilter: false,
    editable: false,
    hide: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 200,
    maxWidth: 250,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Quantity",
    field: "quantity",
    type: "rightAligned",
    valueFormatter: myValueFormatter_quantity,
    floatingFilter: false,
    filter: "agNumberColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (params.node.data.quantity < 0) {
        return {
          display: "flex",
          alignItems: "center",
          border: "2px solid red",
          justifyContent: "flex-end",
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "1px solid #DFDFDF",
          justifyContent: "flex-end",
        };
      }
    },
    minWidth: 100,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  

  {
    headerName: "Current Rate",
    field: "rate",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 120,
    maxWidth: 130,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    valueFormatter: rateFormatter
  },
  {
    headerName: "New Rate",
    headerComponentParams: {
      template: `
      <div class="ag-cell-label-container" role="presentation">
    <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true"></span>
    <div ref="eLabel" class="ag-header-cell-label" role="presentation">
        <img class="me-1" height="14px" width="14px" src="${editIcon}" /> 
        <span ref="eText" class="ag-header-cell-text"></span>
        <span ref="eFilter" class="ag-header-icon ag-header-label-icon ag-filter-icon" aria-hidden="true"></span>
        <span ref="eSortOrder" class="ag-header-icon ag-header-label-icon ag-sort-order" aria-hidden="true"></span>
        <span ref="eSortAsc" class="ag-header-icon ag-header-label-icon ag-sort-ascending-icon" aria-hidden="true"></span>
        <span ref="eSortDesc" class="ag-header-icon ag-header-label-icon ag-sort-descending-icon" aria-hidden="true"></span>
        <span ref="eSortNone" class="ag-header-icon ag-header-label-icon ag-sort-none-icon" aria-hidden="true"></span>
    </div>
</div>`
    },
    field: "newValue",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    tooltipComponentParams: function (params: any) {
      if (
        params.node.data.newValue < -999.9999 ||
        params.node.data.newValue > 999.9999 ||
        params.node.data.newValue === ""
      ) {
        return {
          message: "Invalid Rate",
        };
      }
    },
    cellStyle: function (params: any) {
      if (params.node.data.newValue < -999.9999 ||
        params.node.data.newValue > 999.9999 ||
        /[A-Za-z !@#$%&*()+=?]/gm.test(params.node.data.newValue)) {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "1px solid #DFDFDF",
          backgroundColor: status.error
        }
      }
      else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "1px solid #DFDFDF",
        }
      }

    },
    minWidth: 130,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
      columns:`<i class="fa fa-handshake"/>`
    },
    valueFormatter: rateFormatter
  },
];